import React from 'react';
import PropertyCard from 'components/propertycard';
import Loader from 'components/loader';
import { GetSectionCustomizationOptions } from './util';
import AdComponent from 'components/adcomponent';
import CommonAdComponent from 'components/commonadcomponent';

//const SiteCustomizationOptions = GetSiteCustomizationOptions();
const SearchPageCustomizationOptions = GetSectionCustomizationOptions("SearchPageOptions");
const AdCustomizationOptions = GetSectionCustomizationOptions("AdOptions");

class SearchResult extends React.Component{
    
    constructor(props)
    {
        super(props);

        this.onBookmarkChanged = this.onBookmarkChanged.bind(this);
        this.onFavoriteChanged = this.onFavoriteChanged.bind(this);
    }
    
    onBookmarkChanged(objResponse)
    {
        if(objResponse && this.props.onPageReload)
        {
            this.props.onPageReload(objResponse);
        }
    }
    
    onFavoriteChanged(objResponse)
    {
        if(objResponse && this.props.onPageReload)
        {
            this.props.onPageReload(objResponse);
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if (nextProps.properties !== this.props.properties)
        {
            //console.log(nextProps);
            //console.log('Property Widget Rerender');
            return true;
        }

        // Check for column width change
        if (nextProps.classname !== this.props.classname)
        {
            return true;
        }
        return false
    }

    render() {
        //console.log('Search Results Rendered');
        var returnData = (<div className="col-sm-12 text-center">No properties found matching your search criteria.<br/><br/></div>);
        if(this.props && this.props.initialLoad){
            returnData = (<Loader message={'Loading properties...'} />);
        }
        if (this.props && this.props.properties && this.props.properties.length > 0){
            var self = this;
            returnData = [];
            var adCnt = 0;
            //returnData.push(this.props.properties.map(function(property, i){
            this.props.properties.map(function(property, i){
                /*return <PropWidgetDetailed
                        key={i} property={property}
                        classname={self.props.classname}
                        marginBottom={self.props.marginBottom}
                        highlightMarker={self.props.highlightMarker}
                        playdownMarker={self.props.playdownMarker}
                        imageType={self.props.imageType} />;*/
                        
                if(window.sessionStorage.getItem("APIAudience") === 'agents/' && self.props.bookmarkedItems)
                {
                    property.IB = self.props.bookmarkedItems.indexOf(property.Id) !== -1;   
                }

                if((i === 2 || i === 8 || i === 20 || i === 30 || i === 40 || i === 50 || i === 60 || i === 70 || i === 80 || i === 90 || i === 100)){
                    if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowCustomAds && self.props.adsList && self.props.adsList.length > adCnt && self.props.adsList[adCnt]){
                        returnData.push(<CommonAdComponent key={"Ad_" + i} adObj={self.props.adsList[adCnt]} classname="prop_card" />);
                        adCnt++;
                    }
                    else if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowAds &&
                        AdCustomizationOptions && AdCustomizationOptions.AdsList && AdCustomizationOptions.AdsList.length > 0){
                        returnData.push(<AdComponent key={"Ad_" + i} classname={(self.props.classname && self.props.classname !== "") ? self.props.classname : "prop_card"} renderWhenViewable={false} adIndex={3} />)
                    }                    
                }

                returnData.push(
                    <PropertyCard
                            key={i} property={property}
                            classname={self.props.classname}
                            marginBottom={self.props.marginBottom}
                            highlightMarker={self.props.highlightMarker}
                            playdownMarker={self.props.playdownMarker}
                            imageType={self.props.imageType}
                            onMarkBookmarkFromClient={self.props.onMarkBookmarkFromClient}
                            onBookmarkClicked={self.props.onBookmarkClicked}
                            onBookmarkChanged={self.onBookmarkChanged}
                            bookmarkedItems={self.props.bookmarkedItems}
                            showNotification={self.props.showNotification}
                            onFavoriteChanged={self.onFavoriteChanged}
                            fetchingResult={false} 
                            LazyLoad={false}
                            history={self.props.history}
                            fromSearchPage={self.props.fromSearchPage}
                            onListingRemoved={self.props.onListingRemoved}
                            showHighlightMarker={true}
                            />
                    );   
                    
                return null;
            });
        }

        return (
            <div className="prop_search_list">{/* <div className="new_searchlist property-item-box"> */}{returnData}</div>
        );
    }
}

export default SearchResult;